/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Legend_AllowedInputs */

const en_pol_legend_allowed = /** @type {(inputs: Pol_Legend_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The provider allows this in writing.`)
};

const id_pol_legend_allowed = /** @type {(inputs: Pol_Legend_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyedia mengizinkan cara ini secara tertulis.`)
};

/**
* | output |
* | --- |
* | "The provider allows this in writing." |
*
* @param {Pol_Legend_AllowedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_legend_allowed = /** @type {((inputs?: Pol_Legend_AllowedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Legend_AllowedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_legend_allowed(inputs)
	return en_pol_legend_allowed(inputs)
});